<template>
  <div class="Videos" style="width: 300px">
    <el-upload
        :action="url"
        :limit="1"
        :headers="{token:this.$store.getters.getToken}"
        :on-success="onSuccess"
        :before-upload="beforeUpload"
        :on-remove="onRemove"
        :file-list="file_list"
        with-credentials
        auto-upload>
      <div slot="tip" class="el-upload__tip">Only in MP4 format, under 20 MB</div>
      <el-button if size="medium" type="primary">Upload<i class="el-icon-upload el-icon--right"></i></el-button>
    </el-upload>
  </div>
</template>

<script>
  import {baseURL} from '@/utils/util'

  export default {
    props: ['input'],
    data: () => {
      return {
        url: `${baseURL}/bk_video/upload`,
        file_list: []
      }
    },
    watch: {
      input: {
        handler() {
          if (this.input !== '') {
            this.file_list.push({
              name: [...this.input.split('/')].pop(),
              url: this.input
            })
          }
        },
        deep: true
      }
    },
    methods: {
      beforeUpload(file) {
        const isMP4 = file.type === 'video/mp4';
        const isLt20M = file.size / 1024 / 1024 < 20;
        if (!isMP4) {
          this.$message.error('Only MP4 formatted is accepted!');
        }
        if (!isLt20M) {
          this.$message.error('Video size should not exceed 20 MB');
        }
        return isMP4 && isLt20M;
      },
      onSuccess(e) {
        if (e.errcode === 0) {
          this.$emit('output', {
            video_path: e.video_path,
            video_ratio: e.video_ratio
          })
        }
      },
      onRemove() {
        this.$emit('remove')
      }
    }
  };
</script>
